import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';

import {
  generateTtsRequest,
  setTtsAudioUrl,
} from '../../../../../store/actions/voice-bots-tts';

import { Button } from './styles';

const sanitizeStringToCRM = (_value) => {
  const sanitizeConf = {
    allowedTags: ['button'],
    allowedAttributes: { button: ['*'] },
  };

  return sanitizeHtml(_value, sanitizeConf);
};

const parseAudioTagToPlayTTS = (text) => {
  const sanitizedText = sanitizeStringToCRM(text);
  const splitedText = sanitizedText.split(/(<button\s[\s\S]+?<\/button>)/gi);

  if (splitedText.length <= 1) {
    return text;
  }

  const textWithAudioTag = splitedText
    .map((element) => {
      const isButtonElement = element.startsWith('<button');

      if (isButtonElement) {
        const audioIdCrm = element.match(/data-id-crm="([\S]+)"/)?.[1];
        return `<audio src="${audioIdCrm}" />`;
      }

      return element;
    })
    .join('');

  return textWithAudioTag;
};

const ButtonTestTts = ({ text, itemId }) => {
  const [currentAudio, setCurrentAudio] = useState(null);

  const { loadingGenerateTts, audioUrl } = useSelector(
    (state) => state.voiceBotTts
  );
  const currentItemId = useSelector((state) => state.items?.currentItem?._id);

  const { bot } = useSelector((state) => state.bots);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTtsAudioUrl(null));
  }, [currentItemId]);

  const handlePauseAudio = useCallback(() => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      dispatch(setTtsAudioUrl(null));
    }
  }, [currentAudio]);

  const handlePlayAudio = useCallback((url) => {
    handlePauseAudio();

    const audio = new Audio(url);
    setCurrentAudio(audio);
    audio.play();
    audio.addEventListener('ended', () => dispatch(setTtsAudioUrl(null)));
  }, []);

  useEffect(() => {
    if (audioUrl) {
      handlePlayAudio(audioUrl);
    } else {
      setCurrentAudio(null);
    }
  }, [audioUrl, handlePlayAudio, itemId, currentItemId]);

  const handleGenerateTts = () => {
    const { idProject, idIvrVoice } = bot.voiceSettings;
    const formattedTextToTts = parseAudioTagToPlayTTS(text);
    dispatch(
      generateTtsRequest({ text: formattedTextToTts, idProject, idIvrVoice })
    );
  };

  return (
    <>
      {currentAudio ? (
        <Button onClick={handlePauseAudio}>Parar Áudio</Button>
      ) : (
        <Button onClick={handleGenerateTts} disabled={loadingGenerateTts}>
          Testar Áudio
        </Button>
      )}
    </>
  );
};

export default ButtonTestTts;
